import { CALL_API, METHODS } from 'app/react/state/middleware/api'
import * as Endpoints from './endpoints'
import * as Schemas from './schemas'

export const ONE_REQUEST = 'ONE_ACCOUNT_ARTISTS_ITEM_REQUEST';
export const ONE_SUCCESS = 'ONE_ACCOUNT_ARTISTS_ITEM_SUCCESS';
export const ONE_FAILURE = 'ONE_ACCOUNT_ARTISTS_ITEM_FAILURE';
export const ONE_TYPES = [
    ONE_REQUEST,
    ONE_SUCCESS,
    ONE_FAILURE
];

export const ALL_REQUEST = 'ALL_ACCOUNT_ARTISTS_ITEMS_REQUEST';
export const ALL_SUCCESS = 'ALL_ACCOUNT_ARTISTS_ITEMS_SUCCESS';
export const ALL_FAILURE = 'ALL_ACCOUNT_ARTISTS_ITEMS_FAILURE';
export const ALL_TYPES = [
    ALL_REQUEST,
    ALL_SUCCESS,
    ALL_FAILURE
];

export const fetchAll = (accountId) => ({
    [CALL_API]: {
        types: ALL_TYPES,
        method: METHODS.GET,
        endpoint: Endpoints.fetchAll(accountId),
        schema: Schemas.entities
    },
    accountId
});

export const createOne = (accountId, values) => ({
    [CALL_API]: {
        types: ONE_TYPES,
        method: METHODS.POST,
        body: values,
        endpoint: Endpoints.createOne(accountId),
        schema: Schemas.entity
    },
    accountId
});

export const updateOne = (accountId, itemId, values) => ({
    [CALL_API]: {
        types: ONE_TYPES,
        method: METHODS.PUT,
        body: values,
        endpoint: Endpoints.updateOne(accountId, itemId),
        schema: Schemas.entity
    },
    accountId
});


export const deleteOne = (accountId, itemId) => ({
    [CALL_API]: {
        types: ONE_TYPES,
        method: METHODS.DELETE,
        endpoint: Endpoints.deleteOne(accountId, itemId),
        schema: Schemas.entity,
        id: itemId
    },
    accountId
});



